import React from 'react';
import { Route } from 'react-router-dom';
import LibraryReport from '@/pages/reports/LibraryReport';
import HostelReport from '@/pages/reports/HostelReport';
import TransportReport from '@/pages/reports/TransportReport';
import StaffLeaveReport from '@/pages/reports/StaffLeaveReport';
import ReportsStaffAttendanceReport from '@/pages/reports/StaffAttendanceReport';
import StudentLeaveReport from '@/pages/reports/StudentLeaveReport';
import StudentAttendanceReport from '@/pages/reports/StudentAttendanceReport';
import ReportsSalaryReport from '@/pages/reports/SalaryReport';
import TaxReport from '@/pages/reports/TaxReport';
import DayBook from '@/pages/reports/DayBook';
import CashBook from '@/pages/reports/CashBook';
import BankBook from '@/pages/reports/BankBook';
import LibraryFeeReport from '@/pages/reports/LibraryFeeReport';
import LibraryFineReport from '@/pages/reports/LibraryFineReport';
import ReportsHostelDamageFine from '@/pages/reports/HostelDamageFine';
import LateFeeReport from '@/pages/reports/LateFeeReport';
import LibraryDamageReport from '@/pages/reports/LibraryDamageReport';
import InventoryDamageReport from '@/pages/reports/InventoryDamageReport';
import InventoryReturnReport from '@/pages/reports/InventoryReturnReport';
import SeatBookingReport from '@/pages/reports/SeatBookingReport';
import ReportsAdmissionReport from '@/pages/reports/AdmissionReport';
import ReportsFeesReport from '@/pages/reports/FeesReport';
import IncomeReportMain from '@/pages/reports/IncomeReportMain';
import ExpensesReport from '@/pages/reports/ExpensesReport';
import InventoryReportMain from '@/pages/reports/InventoryReport';
import NAACReports from '@/pages/reports/NAACReports';

export const reportsRoutes = (
  <React.Fragment>
    <Route path="reports/naac" element={<NAACReports />} />
    <Route path="reports/library" element={<LibraryReport />} />
    <Route path="reports/hostel" element={<HostelReport />} />
    <Route path="reports/transport" element={<TransportReport />} />
    <Route path="reports/staff-leave" element={<StaffLeaveReport />} />
    <Route path="reports/staff-attendance" element={<ReportsStaffAttendanceReport />} />
    <Route path="reports/student-leave" element={<StudentLeaveReport />} />
    <Route path="reports/student-attendance" element={<StudentAttendanceReport />} />
    <Route path="reports/salary" element={<ReportsSalaryReport />} />
    <Route path="reports/tax" element={<TaxReport />} />
    <Route path="reports/daybook" element={<DayBook />} />
    <Route path="reports/cashbook" element={<CashBook />} />
    <Route path="reports/bankbook" element={<BankBook />} />
    <Route path="reports/library-fee" element={<LibraryFeeReport />} />
    <Route path="reports/library-fine" element={<LibraryFineReport />} />
    <Route path="reports/hostel-damage-fine" element={<ReportsHostelDamageFine />} />
    <Route path="reports/late-fee" element={<LateFeeReport />} />
    <Route path="reports/library-damage" element={<LibraryDamageReport />} />
    <Route path="reports/inventory-damage" element={<InventoryDamageReport />} />
    <Route path="reports/inventory-return" element={<InventoryReturnReport />} />
    <Route path="reports/seat-booking" element={<SeatBookingReport />} />
    <Route path="reports/admission" element={<ReportsAdmissionReport />} />
    <Route path="reports/fees" element={<ReportsFeesReport />} />
    <Route path="reports/income" element={<IncomeReportMain />} />
    <Route path="reports/expenses" element={<ExpensesReport />} />
    <Route path="reports/inventory" element={<InventoryReportMain />} />
  </React.Fragment>
);
